interface StructuredDataSchemaProps {
  schema: object;
  schemaId?: string;
}

/**
 * Server component to render structured data schema (JSON-LD) in the page head
 * This ensures schemas are in the initial HTML for crawlers
 */
export default function StructuredDataSchema({ schema, schemaId }: StructuredDataSchemaProps) {
  const id = schemaId || 'structured-data-schema';
  
  return (
    <script
      id={id}
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema),
      }}
    />
  );
}
